import { render } from "./TermsPageCMS.vue?vue&type=template&id=a718fb16"
import script from "../js/terms-page-cms.js?vue&type=script&lang=js"
export * from "../js/terms-page-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__